import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";

type ButtonPropsDI = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "submit" | "button" | "reset"; // Explicitly typing the 'type' property
  children?: any;
  variant?: "filled" | "empty";
  disabled?: boolean;
  "aria-label"?: string;
  id?: string;
};

const defaultProps = {
  type: "button" as "button", // סוג ברור
  variant: "filled",
  disabled: false,
};

const ColorButton = styled(Button)(({ theme }) => ({
  fontFamily: "FbReforma-Medium",
  backgroundColor: "#00458a",
  fontSize: "16px",
  color: "white",
  height: "40px",
  minWidth: "150px",
  borderRadius: "20px",
  "&:hover": {
    backgroundColor: "#00458a",
    opacity: 0.65,
  },
  "&:focus": {
    outline: "2px solid #0d6efd",
  },
  "&:disabled": {
    opacity: "35%",
    color: "white",
    backgroundColor: "#00458a",
  },
}));

const ButtonWrapper = (p: ButtonPropsDI) => {
  const props = {
    ...defaultProps,
    ...p,
  };
  return (
    <ColorButton
      aria-label={props["aria-label"]}
      onClick={props.onClick}
      type={props.type} 
      variant={props.variant === "filled" ? "contained" : "outlined"}
      disabled={props.disabled}
      id={props.id ?? ""}
    >
      {props.children}
    </ColorButton>
  );
};

ButtonWrapper.defaultProps = defaultProps;

export default ButtonWrapper;
